import * as React from "react"
import { Updater, IOWidget, fromJSX } from "widgets-for-react"
import { CMSState } from "../../../../cms/blocks/types.gen"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types.ext.gen"

type DisplayModes = 'flat-image' | '360-image'
export type Image360BlockProps = {
    index: number
    image: ParsedMediaImage
    previewImage: ParsedMediaImage
    mode: DisplayModes
}

export type Image360BlockStyle = Partial<{}>

let toggle_mode = (newMode: DisplayModes, block_index: number) => (s0: CMSState): CMSState => {
    let current_block = s0.blocks.get(block_index)
    if (current_block.kind == 'Image360Block') {
        if (current_block.value[0].mode != newMode) {
            return {
                ...s0,
                blocks: s0.blocks.set(block_index,
                    {
                        ...current_block,
                        value: [
                          { ...current_block.value[0], mode: newMode },
                          { ...current_block.value[1] }
                        ]
                    }
                )
            }
        }
    }
    return s0
}


export function Image360Block(
    props: Image360BlockProps,
    options?: { style?: Image360BlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
    return (s0: CMSState) =>
        fromJSX((setState) => {
                    let image = s0.images.get(props.image.field_media_image?.image?.id)
                    let previewImage = s0.images.get(props.previewImage.field_media_image?.image?.id)
                    return image?.kind == 'loaded' && image.value.get('full') && previewImage?.kind == 'loaded' ? (
                      <div className="block block--360 ls-block-spacing">
                        <div className="block__inner ls-container">
                          {props.mode == 'flat-image' ? (
                            <div className="block__visual">
                              <img loading="lazy" src={previewImage.value.get('2880w')} alt="" />
                            </div>
                          ) : (
                            <div>
                              <button
                                className="block__action"
                                onClick={() => setState((s) => toggle_mode('flat-image', props.index)(s))}
                              >
                                <svg className="block__icon" aria-hidden="true" height="20" width="20">
                                  <use xlinkHref="#icon--cross" />
                                </svg>
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )
            }
        )
}